<template>
  <div :class="styleType===null||styleType==='origin'||this.styleType==='0'?'my_outbox':`my_outbox_${styleType}`">
    <div class="my-inbox" ref='box'>
      <div class="my-list" v-for="(ele,index) in attention" :key='index'>{{ ele['title'] }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name:'marquee',
  props:['attention'],
  data() {
    return {
      styleType:'origin',
      initLeft:0,
      animateTarget:null
    }
  },
  mounted:function(){
    this.animateTarget = this.$refs.box;
    requestAnimationFrame(this.animateFn);
  },
  created() {
    // 初始化加载样式
    this.loadLessStyle()
  },
  methods:{
    animateFn(){
      this.initLeft+=0.5;
      if (this.initLeft >= (this.animateTarget.offsetWidth+400)) {
        this.initLeft = 0;
      }
      this.animateTarget.style = "transform: translateX(-" + this.initLeft + "px)";
      requestAnimationFrame(this.animateFn)
    },
    loadLessStyle() {
      this.styleType = localStorage.getItem('styleType') === null||localStorage.getItem('styleType')==='0'? 'origin' : localStorage.getItem('styleType')
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/components/marquee/marquee.less";
</style>
